import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';
import { useVisDisplayMode } from '@/hooks/useVisDisplayMode';
import { VisDisplayMode } from '@/types/visualisation';

export const VisSectionContainer = ({ children }: { children: ReactNode }) => {
  const [visDisplayMode] = useVisDisplayMode();

  return (
    <div className={twJoin('flex flex-col h-full', visDisplayMode === VisDisplayMode.BOTH && 'gap-2')}>{children}</div>
  );
};
